// @ts-nocheck
import camelCase from 'camelcase';
import * as R from 'ramda';

import * as integrationsConstants from '../action/api/constants/Integrations.js';
import * as uiTypes from '../action/ui/constants/integrationsActionsConstants.js';
import {
  getErrorDetailsResponse,
  getErrorMessageResponse,
  getInputErrors,
} from '../utils/integrations.js';
import {
  getUserIntegrationKey,
  normalizeServerName,
} from '../utils/normalizeNames.js';

const initialState = {
  userIntegrations: {
    adformAdServer: {
      count: 0,
      integrations: [],
      isBothSidesIntegration: null,
    },
    campaignManager: {
      count: 0,
      integrations: [],
      isBothSidesIntegration: null,
    },
    googleAnalytics: {
      count: 0,
      integrations: [],
      isBothSidesIntegration: null,
    },
    appsflyer: {
      count: 0,
      integrations: [],
      error: getInputErrors('appsflyer'),
    },
  },
  selectedIntegration: {},
  adformOptions: {
    advertisers: [],
  },
  campaignManagerUsers: [],
  campaignManagerAdvertisers: [],
  platformsMeta: {},
  APIError: {
    add: {
      error: false,
      message: '',
    },
    patch: {
      error: false,
      message: '',
    },
    delete: {
      error: false,
      message: '',
    },
    subAccounts: {
      error: false,
      message: '',
    },
  },
  verifyIntegrationLoading: false,
  failedVerifyIntegrations: [],
};

type action = {
  type: string;
  data: any;
  provider: string;
  integrationId: string;
};

const handleIntegrationRequest = (state, action) => ({
  ...state,
  userIntegrations: {
    ...state.userIntegrations,
    [getUserIntegrationKey(action.provider)]: {
      ...state.userIntegrations[getUserIntegrationKey(action.provider)],
      error: getInputErrors(getUserIntegrationKey(action.provider)),
    },
  },
});

const reducer = (state = initialState, action: action) => {
  switch (action.type) {
    case integrationsConstants.GET_CAMPAIGN_MANAGER_USERS.SUCCESS:
      return {
        ...state,
        campaignManagerUsers: action.data,
      };
    case integrationsConstants.GET_CAMPAIGN_MANAGER_ADVERTISERS.SUCCESS:
      return {
        ...state,
        campaignManagerAdvertisers: action.data,
      };
    case integrationsConstants.GET_VERIFY_INTEGRATION.REQUEST:
      return {
        ...state,
        verifyIntegrationLoading: true,
      };
    case integrationsConstants.GET_VERIFY_INTEGRATION.FAILED: {
      return {
        ...state,
        verifyIntegrationLoading: false,
      };
    }
    case integrationsConstants.GET_VERIFY_INTEGRATION.SUCCESS: {
      const failedVerifyIntegrations = [...state.failedVerifyIntegrations];
      const failedVerifyIntegrationIndex = failedVerifyIntegrations.findIndex(
        (integration) => integration.integrationId === action.integrationId,
      );

      if (failedVerifyIntegrationIndex !== -1) {
        failedVerifyIntegrations[failedVerifyIntegrationIndex] = {
          data: action.data.data.additional,
          integrationId: action.integrationId,
        };
      } else {
        failedVerifyIntegrations.push({
          data: action.data.data.additional,
          integrationId: action.integrationId,
        });
      }

      return {
        ...state,
        failedVerifyIntegrations: failedVerifyIntegrations,
      };
    }

    case integrationsConstants.GET_ADFORM_INTEGRATIONS.SUCCESS:
      return {
        ...state,
        userIntegrations: {
          ...state.userIntegrations,
          adformAdServer: action.data,
        },
      };

    case integrationsConstants.PATCH_CAMPAIGN_MANAGER_SUB_ACCOUNT.SUCCESS: {
      return (
        R.over(
          R.lensPath([
            'userIntegrations',
            camelCase(action.provider),
            'integrations',
          ]),
          R.map(
            R.when(
              R.propEq('id', action.integrationId),
              R.mergeLeft(action.data),
            ),
          ),
          state,
        ),
        {
          ...state,
          APIError: {
            ...state.APIError,
            patch: {
              error: false,
              message: 'Integration was successfully integrated',
            },
          },
        }
      );
    }

    case integrationsConstants.PATCH_CAMPAIGN_MANAGER_SUB_ACCOUNT.FAILED: {
      return {
        ...state,
        APIError: {
          ...state.APIError,
          patch: {
            error: true,
            message: action.error.response.statusText,
            details:
              action.errorData.nonFieldErrors[0] || action.errorData.details,
          },
        },
      };
    }

    case integrationsConstants.ADD_INTEGRATION.SUCCESS: {
      if (
        action.data.type === 'ghost_campaign' ||
        action.data.type === 'media_ad_network_campaign'
      ) {
        return {
          ...state,
          userIntegrations: {
            ...state.userIntegrations,
            [camelCase(action.data.provider)]: {
              ...state.userIntegrations[camelCase(action.data.provider)],
              integrations: [
                ...(state.userIntegrations[camelCase(action.data.provider)]
                  ?.integrations || []),
                {
                  ...action.data,
                  integrationType: action.data.channel,
                  isGhost: true,
                  provider: camelCase(action.data.provider),
                },
              ],
            },
          },
        };
      }

      if (action.data.platform === 'adform_ad_server') {
        return {
          ...state,
          APIError: {
            ...state.APIError,
            add: {
              error: false,
              message: 'Integration was successfully confirmed',
            },
          },
          userIntegrations: {
            ...state.userIntegrations,
            [camelCase(normalizeServerName(action.provider))]: {
              ...state.userIntegrations[
                camelCase(normalizeServerName(action.provider))
              ],
              integrations: [
                ...(state.userIntegrations[
                  camelCase(normalizeServerName(action.provider))
                ]?.integrations || []),
                action.data,
              ],
            },
          },
          selectedIntegration: action.data,
        };
      }

      if (action.data.platform === 'campaign_manager') {
        return {
          ...state,
          APIError: {
            ...state.APIError,
            add: {
              error: false,
              message: 'Integration was successfully confirmed',
            },
          },
          userIntegrations: {
            ...state.userIntegrations,
            [camelCase(normalizeServerName(action.provider))]: {
              ...state.userIntegrations[
                camelCase(normalizeServerName(action.provider))
              ],
              integrations: [
                ...(state.userIntegrations[
                  camelCase(normalizeServerName(action.provider))
                ]?.integrations || []),
                {
                  ...action.data,
                  isOauthConnected: true,
                  isRefreshTokenValid: true,
                },
              ],
            },
          },
          selectedIntegration: {
            ...action.data,
            isOauthConnected: true,
            isRefreshTokenValid: true,
          },
        };
      }

      let newInt = { ...action.data };

      if (
        ['appsflyer', 'linkedinIntegrated'].includes(
          getUserIntegrationKey(action.provider),
        )
      ) {
        newInt = { ...action.data.data.items[0], platform: action.provider };
      }

      return {
        ...state,
        APIError: {
          ...state.APIError,
          add: {
            error: false,
            message: 'Your account has been connected successfully',
          },
        },
        userIntegrations: {
          ...state.userIntegrations,
          [getUserIntegrationKey(action.provider)]: {
            ...state.userIntegrations[getUserIntegrationKey(action.provider)],
            integrations: [
              newInt,
              ...(state.userIntegrations[getUserIntegrationKey(action.provider)]
                ?.integrations || []),
            ],
          },
        },
        selectedIntegration: newInt,
      };
    }
    case integrationsConstants.ADD_INTEGRATION.REQUEST:
      return handleIntegrationRequest(state, action);

    case integrationsConstants.ADD_INTEGRATION.FAILED:
      return {
        ...state,
        userIntegrations: {
          ...state.userIntegrations,
          [getUserIntegrationKey(action.provider)]: {
            ...state.userIntegrations[getUserIntegrationKey(action.provider)],
            error: getInputErrors(
              getUserIntegrationKey(action.provider),
              action,
            ),
          },
        },
        APIError: {
          add: {
            error: true,
            message: getErrorMessageResponse(action),
            details: getErrorDetailsResponse(action),
          },
        },
      };

    case integrationsConstants.REQUEST_APPOINTMENT.SUCCESS:
      return {
        ...state,
        userIntegrations: {
          ...state.userIntegrations,
          [action.config.data.provider]: [
            ...(state.userIntegrations[action.config.data.provider] || []),
            action.data,
          ],
        },
      };
    case integrationsConstants.PATCH_INTEGRATION.SUCCESS: {
      const providersWithItegrate = ['adform_ad_server', 'campaign_manager'];
      const currentIntegrations = {
        ...state.userIntegrations[getUserIntegrationKey(action.provider)],
      };

      if (action.data.default) {
        currentIntegrations.integrations = currentIntegrations.integrations.map(
          (item) => ({
            ...item,
            default: false,
          }),
        );
      }

      let updatedInt = action.data;
      if (
        ['appsflyer', 'linkedinIntegrated'].includes(
          getUserIntegrationKey(action.provider),
        )
      ) {
        updatedInt = action.data.data.items[0];
      }

      return {
        ...state,
        APIError: {
          ...state.APIError,
          patch: {
            error: false,
            message: providersWithItegrate.includes(
              getUserIntegrationKey(action.provider),
            )
              ? 'Integration was successfully confirmed'
              : 'Your account has been updated successfully',
          },
        },
        userIntegrations: {
          ...state.userIntegrations,
          [getUserIntegrationKey(action.provider)]: {
            ...currentIntegrations,
            integrations: currentIntegrations.integrations?.map((item) =>
              item.id === updatedInt.id ? updatedInt : item,
            ),
          },
        },
        selectedIntegration: updatedInt,
      };
    }

    case integrationsConstants.PATCH_INTEGRATION.REQUEST:
      return handleIntegrationRequest(state, action);

    case integrationsConstants.PATCH_INTEGRATION.FAILED:
    case integrationsConstants.PUT_INTEGRATION.FAILED:
      return {
        ...state,
        userIntegrations: {
          ...state.userIntegrations,
          [getUserIntegrationKey(action.provider)]: {
            ...state.userIntegrations[getUserIntegrationKey(action.provider)],
            error: getInputErrors(
              getUserIntegrationKey(action.provider),
              action,
            ),
          },
        },
        APIError: {
          ...state.APIError,
          patch: {
            error: true,
            message: getErrorMessageResponse(action),
            details: getErrorDetailsResponse(action),
          },
        },
      };

    case integrationsConstants.PUT_INTEGRATION.SUCCESS: {
      const providersWithItegrate = ['adform_ad_server', 'campaign_manager'];
      const currentIntegrations = {
        ...state.userIntegrations[getUserIntegrationKey(action.provider)],
      };

      if (action.data.default) {
        currentIntegrations.integrations = currentIntegrations.integrations.map(
          (item) => ({
            ...item,
            default: false,
          }),
        );
      }

      const updatedInt = action.data;

      return {
        ...state,
        APIError: {
          ...state.APIError,
          patch: {
            error: false,
            message: providersWithItegrate.includes(
              getUserIntegrationKey(action.provider),
            )
              ? 'Integration was successfully confirmed'
              : 'Your account has been updated successfully',
          },
        },
        userIntegrations: {
          ...state.userIntegrations,
          [getUserIntegrationKey(action.provider)]: {
            ...currentIntegrations,
            integrations: currentIntegrations.integrations.map((item) =>
              item.id === updatedInt.id ? updatedInt : item,
            ),
          },
        },
        selectedIntegration: updatedInt,
      };
    }

    case integrationsConstants.PUT_INTEGRATION.REQUEST:
      return {
        ...state,
        userIntegrations: {
          ...state.userIntegrations,
          [getUserIntegrationKey(action.provider)]: {
            ...state.userIntegrations[getUserIntegrationKey(action.provider)],
            error: getInputErrors(getUserIntegrationKey(action.provider)),
          },
        },
      };

    case integrationsConstants.DELETE_INTEGRATION.SUCCESS: {
      if (action.payload.provider === 'ghost') {
        return {
          ...state,
          selectedIntegration: {},
          APIError: {
            ...state.APIError,
            delete: {
              error: false,
              message: 'Integration was successfully deleted',
            },
          },
        };
      }

      const currentIntegrations = {
        ...state.userIntegrations[
          getUserIntegrationKey(action.payload.provider)
        ],
      };

      return {
        ...state,
        userIntegrations: {
          ...state.userIntegrations,
          [getUserIntegrationKey(action.payload.provider)]: {
            ...currentIntegrations,
            integrations: currentIntegrations.integrations?.filter(
              ({ id }) => id !== action.payload.id,
            ),
          },
        },
        selectedIntegration: {},
        APIError: {
          ...state.APIError,
          delete: {
            error: false,
            message: 'Integration was successfully deleted',
          },
        },
      };
    }

    case integrationsConstants.DELETE_INTEGRATION.FAILED:
      return {
        ...state,
        APIError: {
          ...state.APIError,
          delete: {
            error: true,
            message: getErrorMessageResponse(action),
            details: getErrorDetailsResponse(action),
          },
        },
      };
    case integrationsConstants.OPTIONS_INSTAGRAM_ACCOUNTS.SUCCESS:
      return {
        ...state,
        instagramAccounts: action.data.actions.post.accountId.choices,
      };

    case integrationsConstants.GET_ADFORM_ADVERTISERS.SUCCESS:
      return {
        ...state,
        adformOptions: {
          ...state.adformOptions,
          advertisers: action.data,
        },
      };

    case integrationsConstants.PATCH_ADFORM_ADVERTISER.SUCCESS:
      return {
        ...state,
        selectedIntegration: {
          ...state.selectedIntegration,
          advertiser: action.data.advertiser,
        },
        userIntegrations: {
          ...state.userIntegrations,
          adformAdServer: {
            ...state.userIntegrations.adformAdServer,
            integrations:
              state.userIntegrations.adformAdServer.integrations.map(
                (integration) => {
                  if (integration.id === action.data.id) {
                    return {
                      ...integration,
                      advertiser: action.data.advertiser,
                    };
                  }
                  return integration;
                },
              ),
          },
        },
      };

    case integrationsConstants.PUT_GOOGLE_ANALYTICS_INTEGRATION.SUCCESS:
      return state;

    case integrationsConstants.DELETE_GOOGLE_ANALYTICS_INTEGRATION.SUCCESS:
      return {
        ...state,
        userIntegrations: {
          ...state.userIntegrations,
          googleAnalytics: initialState.userIntegrations.googleAnalytics,
        },
      };

    case uiTypes.ACTIVATE_SELECTED_CM_INTEGRATION:
      return {
        ...state,
        selectedIntegration: {
          ...state.selectedIntegration,
          isActive: true,
        },
        userIntegrations: {
          ...state.userIntegrations,
          campaignManager: {
            ...state.userIntegrations.campaignManager,
            integrations:
              state.userIntegrations.campaignManager.integrations.map(
                (integration) => {
                  if (integration.id === state.selectedIntegration.id) {
                    return {
                      ...integration,
                      isActive: true,
                    };
                  }
                  return integration;
                },
              ),
          },
        },
      };

    case uiTypes.RESET_API_ERROR:
      return {
        ...state,
        APIError: {
          add: {
            error: false,
            message: '',
          },
          patch: {
            error: false,
            message: '',
          },
          delete: {
            error: false,
            message: '',
          },
          subAccounts: {
            error: false,
            message: '',
          },
        },
      };

    case uiTypes.SET_API_ERROR:
      return {
        ...state,
        APIError: {
          add: {
            error: false,
            message: '',
          },
          patch: {
            error: false,
            message: '',
          },
          delete: {
            error: false,
            message: '',
          },
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

export default reducer;
